
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesReturnTaxGrid extends Serenity.EntityGrid<SalesReturnTaxRow, any> {
        protected getColumnsKey() { return 'Sales.SalesReturnTax'; }
        protected getIdProperty() { return SalesReturnTaxRow.idProperty; }
        protected getInsertPermission() { return SalesReturnTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesReturnTaxRow.localTextPrefix; }
        protected getService() { return SalesReturnTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}